module.exports = __webpack_public_path__ + "Flama-BoldItalic.woff2?9a86fe5e8050841aa4b4ea65aa7f2e02";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BoldItalic.woff2
// module id = 911
// module chunks = 0